import _ from "lodash";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import FormCheckbox from "../../components/form/FormCheckbox";
import ModalTabContent from "../../components/modal/ModalTabContent";
import itemCardDetailRows from "../../constants/itemCardDetailRows";
import { appStateSelectors } from "../../modules/appState";
import { mobileItemCardViewSettingsOperations } from "../../modules/definition/mobileItemCardViewSettings";
import { typeSelectors } from "../../modules/definition/types";
import { PropTypeShapes } from "../../types";
import { getShouldShowRelationshipOptions, wrapCheckbox, wrapCheckboxGroup } from "./utils";

// Note: we may split the card view settings by Sequence and Narrative
// so I leave the code of the header row here

// const renderCheckboxHeaderRow = headers => {
//   const fields = _.map(headers, header => {
//     return (
//       <ModalField key={header} flex={1}>
//         <label>{header}</label>
//       </ModalField>
//     );
//   });
//   return (
//     <ModalRow border={true}>
//       <ModalField flex={2} />
//       {fields}
//     </ModalRow>
//   );
// };

const renderCheckboxRow = (rowId, label, isCheckedArray, onChange) => {
  const checkbox = _.map(isCheckedArray, (isChecked, index) => {
    return wrapCheckbox(
      <FormCheckbox
        key={index}
        label={label}
        checkboxState={isChecked}
        onChange={newState => onChange(rowId, index, newState)}
        disabled={_.isNil(isChecked)}
      />,
      index
    );
  });
  return checkbox;
};

const renderCardGroup = (
  label,
  viewSettings,
  changeOperations,
  localDispatch,
  includeNarrative,
  disabledRowIndex = []
) => {
  const narrativeHeaderIndex = 1;
  const narrativeRowIndex = 3;

  let rows = [...itemCardDetailRows];

  rows = rows.filter((r, rIndex) => !disabledRowIndex.includes(rIndex));

  let operations = [changeOperations];

  const onChange = (rowId, columnIndex, newState) => {
    // Which operations block do we want to use, based on columnIndex (which specifies view type)
    const ops = operations[columnIndex];
    // Which operation do we want to use, based on rowId (which specifies property name)
    const row = rows.find(r => r.id === rowId);
    const op = ops[row.onChangeFunctionName];
    localDispatch(op(newState));
  };

  if (!includeNarrative) {
    operations.splice(narrativeHeaderIndex, 1);
    rows.splice(narrativeRowIndex, 1);
  }

  const modalRows = _.map(rows, row => {
    let isCheckedArray = [viewSettings.get(row.id)];
    if (!includeNarrative) {
      isCheckedArray.splice(narrativeHeaderIndex, 1);
    }
    return renderCheckboxRow(row.id, row.label, isCheckedArray, onChange);
  });

  return wrapCheckboxGroup(modalRows, label);
};

const renderNormalCardDetailsGroup = useProps => {
  return renderCardGroup(
    "Card List",
    useProps.mobileItemCardViewSettings,
    mobileItemCardViewSettingsOperations,
    useProps.dispatchLocal,
    useProps.includeNarrative,
    [8]
  );
};

const renderShowRelationshipTypesGroup = useProps => {
  let rows = null;
  const { activeViewType, mobileItemCardViewSettings, referenceTypesOfView, dispatchLocal } = useProps;

  const shouldShowRelationshipOptions = getShouldShowRelationshipOptions(activeViewType);
  if (shouldShowRelationshipOptions) {
    rows = referenceTypesOfView.map((t, index) =>
      wrapCheckbox(
        <FormCheckbox
          key={index}
          label={t.label}
          checkboxState={mobileItemCardViewSettings.showRelationshipTypes.includes(t.id)}
          onChange={_newState =>
            dispatchLocal(mobileItemCardViewSettingsOperations.toggleShowRelationshipTypes([t.id]))
          }
        />,
        index
      )
    );
  }
  return rows && rows.size > 0 ? wrapCheckboxGroup(rows.toArray(), "Relationships") : null;
};

// Moved the settings to the view settings
// See https://bitbucket.org/aeontimeline/aeon-timeline-react/pull-requests/671#comment-222694450

// const renderTimelineViewGroup = useProps => {
//   return renderCardGroup(
//     "Timeline View",
//     useProps.timelineViewSettings,
//     timelineViewSettingsOperations,
//     useProps.dispatchLocal,
//     useProps.includeNarrative
//   );
// };

// const renderNarrativeViewGroup = useProps => {
//   return useProps.includeNarrative
//     ? renderCardGroup(
//       "Narrative View",
//       useProps.narrativeViewSettings,
//       narrativeViewSettingsOperations,
//       useProps.dispatchLocal,
//       useProps.includeNarrative
//     )
//     : null;
// };

const SettingsCardDetailsMobileTab = props => {
  return (
    <ModalTabContent className="settingsCardDetailsMobileTab" scrollable={true}>
      {renderNormalCardDetailsGroup(props)}
      {renderShowRelationshipTypesGroup(props)}
    </ModalTabContent>
  );
};

SettingsCardDetailsMobileTab.propTypes = {
  includeNarrative: PropTypes.bool.isRequired,
  dispatchLocal: PropTypes.func.isRequired,
  mobileItemCardViewSettings: PropTypeShapes.itemCardViewSettings.isRequired,
  narrativeViewSettings: PropTypeShapes.narrativeViewSettings.isRequired,
  timelineViewSettings: PropTypeShapes.timelineViewSettings.isRequired,
  activeViewType: PropTypes.string.isRequired
};

const mapStateToProps = state => {
  const activeViewType = appStateSelectors.getMobilePortraitViewType(state.present);
  return {
    activeViewType,
    referenceTypesOfView: typeSelectors.getReferenceTypesOfViewType(state.present, activeViewType)
  };
};

export default connect(mapStateToProps, null)(SettingsCardDetailsMobileTab);
